import { useEffect } from 'react';

import { useSetRecoilState } from 'recoil';

import { AdminRouter } from '@route/AdminRouter';
import { BugoRouter } from '@route/BugoRouters/BugoRouter';
import { GiftBrandRouter } from '@route/GiftBrandRouters/GiftBrandRouter';
import { GiftSellerRouter } from '@route/GiftSellerRouters/GiftSellerRouter';
import { GiftStoreRouter } from '@route/GiftStoreRouters/GiftStoreRouter';
import { SellerRouter } from '@route/SellerRouters/SellerRouter';
import { StoreRouter } from '@route/StoreRouters/StoreRouter';
import { ScrollToTop } from '@shared/components/ScrollToTop';
import { useCssVariables } from '@shared/hooks/useCssVariables';
import { KakaoCallbackPage } from '@shared/page/KakaoCallbackPage';
import { notificationInstanceAtom } from '@shared/state/atom/notification.atom';
import { UserCustomTheme } from '@shared/types';
import { mainColorGenerator } from '@shared/utils/mainColorGenerator';
import { notification } from 'antd';
import { Route, Routes, useLocation } from 'react-router-dom';

function App() {
  const { pathname } = useLocation();
  const [api, contextHolder] = notification.useNotification();
  const setNotificationInstance = useSetRecoilState(notificationInstanceAtom);

  useCssVariables([
    {
      property: '--main-color',
      value: mainColorGenerator(UserCustomTheme.Preed),
    },
  ]);

  useEffect(() => {
    setNotificationInstance(api);
  }, [api, setNotificationInstance]);

  return (
    <>
      {contextHolder}
      <div>
        <div className="sr-only">
          <p>version 2023/08/05</p>
        </div>
        <ScrollToTop />
        <div className={`${UserCustomTheme.Preed} `}>
          <div className="">
            <div
              className={`mx-auto min-h-screen w-full ${
                pathname.endsWith('-stat') ||
                pathname.endsWith('gift-event-log') ||
                pathname.endsWith('gift-delivery-management') ||
                pathname.endsWith('gift-settlement') ||
                pathname.endsWith('-stat-new') ||
                pathname.includes('flower-seller') ||
                pathname.includes('gift-seller') ||
                pathname.includes('gift-brand') ||
                pathname.includes('admin') ||
                pathname.endsWith('account') ||
                pathname.endsWith('gift-dashboard')
                  ? ''
                  : 'max-w-screen-md'
              }  theme-text-1 theme-bg-6`}
            >
              <Routes>
                <Route path="*" element={<BugoRouter />} />
                <Route path="flower-store/*" element={<StoreRouter />} />
                <Route path="gift-store/*" element={<GiftStoreRouter />} />
                <Route path="flower-seller/*" element={<SellerRouter />} />
                <Route path="gift-seller/*" element={<GiftSellerRouter />} />
                <Route path="gift-brand/*" element={<GiftBrandRouter />} />
                <Route path="admin/*" element={<AdminRouter />} />
                <Route path="social/kakao/auth" element={<KakaoCallbackPage />} />
              </Routes>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default App;
